import React from 'react';
import DataTable from '../../../common/components/DataTable';
import UserIcon from '../../../common/components/UserIcon';
import { options } from '../../pages/UserProfile/Checkout';

function EngagementReport() {
  return (
    <DataTable
      url="/resource/squads?with[]=recentCheckoutFeedback"
      columns={['Squad', 'Reports', 'Mood', 'Engagement', 'Workload']}
      renderRow={(squad) => <SquadRow key={squad.id} squad={squad} />}
    />
  );
}

function SquadRow({ squad }) {
  const feedback = squad.recent_checkout_feedback ?? [];
  return (
    <tr>
      <td>
        <div>
          <strong>{squad.name}</strong>
        </div>
        <div>
          {squad.users.map((user) => <UserIcon key={user.id} user={user} className="mr-1" round />)}
        </div>
      </td>
      <td className="text-muted">
        {feedback.length}
        {' '}
        {squad.recent_checkout_feedback.length === 1 ? 'report' : 'reports'}
      </td>
      <td>
        <FeedbackSummary squad={squad} group="mood" />
      </td>
      <td>
        <FeedbackSummary squad={squad} group="engagement" />
      </td>
      <td>
        <FeedbackSummary squad={squad} group="workload" />
      </td>
    </tr>
  );
}

function summarise(squad, key, initial) {
  if (!squad.recent_checkout_feedback) {
    return null;
  }

  if (!squad.recent_checkout_feedback.length) {
    return null;
  }

  const data = squad.recent_checkout_feedback
    .filter((item) => item[key] !== null);

  if (!data.length) {
    return null;
  }

  return data.reduce((carry, item) => {
    const rtn = carry;

    if (typeof !rtn[item[key]] === 'undefined') {
      rtn[item[key]] = 0;
    }

    rtn[item[key]] += 1;
    return rtn;
  }, initial);
}

function FeedbackSummary({ squad, group = 'workload' }) {
  const extendedOptions = options;
  extendedOptions.mood.bad = {
    icon: '😩',
    title: 'Bad',
    className: 'text-danger',
  };
  extendedOptions.mood['not-so-good'] = {
    icon: '😞',
    title: 'Not so good',
  };
  extendedOptions.workload.pressured = {
    icon: '😓',
    title: 'Pressured',
    className: 'text-danger',
  };

  const keys = Object.keys(options[group]);
  const initial = keys.reduce((carry, key) => {
    const rtn = carry;
    rtn[key] = 0;
    return rtn;
  }, {});

  const data = summarise(squad, group, initial);

  if (!data) {
    return null;
  }

  return (
    <>
      {keys.map((key) => data[key] !== 0 && (
        <div key={key} className={options[group][key].className}>{`${options[group][key].icon} ${options[group][key].title}: ${data[key]}`}</div>
      ))}
    </>
  );
}

export default EngagementReport;
